<app-leveltwo [pageName]="'Mobile Homes'">
    <div heading="General Info" class="General">
      <h3>{{'ManufacturedHomes.PageTitle'|translate}}</h3>
      <!--<h4>{{'ManufacturedHomes.Pagesubtitle'|translate}}</h4>-->
      <h4>{{'ManufacturedHomes.Assessments'|translate}}</h4>
      <p>{{'ManufacturedHomes.Assessmentstext1'|translate}}</p>
      <p>{{'ManufacturedHomes.Assessmentstext2'|translate}}</p>
      <p>{{'ManufacturedHomes.Assessmentstext3'|translate}}</p>
      <!--
      <h4>{{'ManufacturedHomes.Register'|translate}}</h4>
      <p>{{'ManufacturedHomes.Registertext'|translate}}</p>
      -->
      <p>{{'ManufacturedHomes.Formore'|translate}}<br>
      {{'ManufacturedHomes.Website'|translate}}<a class="inline-link" href="https://www.hcd.ca.gov/manufactured-and-mobilehomes/registration-and-titling" target="_blank">hcd.ca.gov/manufactured-and-mobilehomes/registration-and-titling</a><br>
      {{'ManufacturedHomes.Phone'|translate}} <b>1 (800) 952-8356</b></p>
      <hr style="background-color:black">

      <p [innerHTML]="'ManufacturedHomes.CountyTTC'|translate"></p>
      <p>{{'ManufacturedHomes.Website'|translate}}<a class="inline-link" href="https://ttc.lacounty.gov" target="_blank">ttc.lacounty.gov</a><br>
        {{'ManufacturedHomes.Email'|translate}}  <a href="mailto:mobilehome@ttc.lacounty.gov" target="_blank">mobilehome&#64;ttc.lacounty.gov</a><br>
      {{'ManufacturedHomes.Phone'|translate}} <b>1 (213) 893-7935</b></p>




    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
